/**
 * @author HungNS
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./lang/i18n";
import axios from "axios";
import IConstants from "@/common/constants/IConstants.js";
import ServiceUtils from "@/common/utils/ServiceUtils";
import NestedModalConfirm from "@/common/plugins/jquery/NestedModalConfirm.js";
import wanakana from "@/common/utils/wanakana.min.js";
import filters from "@/common/filters/index.js";
import "@/common/directives";
import ModalPlugin from "@/common/plugins/ModalPlugin.js";
import NewsPlugin from "@/common/plugins/NewsPlugin.js";
import BrowserPlugin from "@/common/plugins/BrowserPlugin.js";
import ComponentPlugin from "@/common/plugins/ComponentPlugin.js";
import FactoryService from "@/services/FactoryService.js";
import Vuelidate from 'vuelidate';
import Cookie from 'js-cookie';
import "bootstrap";
import "@/styles/app.css";
import "@/styles/custom.css";
import "@/common/plugins/jquery/passwordStrength";

require('es6-promise').polyfill();
// Transpiler for older browsers
import 'core-js/stable';

Vue.use(ComponentPlugin);
Vue.use(ModalPlugin);
Vue.use(NewsPlugin);
Vue.use(BrowserPlugin);
Vue.use(Vuelidate);

Vue.prototype.$http = axios;
Vue.prototype.$service = FactoryService;
Vue.prototype.$cookie = Cookie;
Vue.prototype.IConstants = IConstants;
Vue.prototype.ServiceUtils = ServiceUtils;
Vue.prototype.NestedModalConfirm = NestedModalConfirm;
Vue.prototype.wanakana = wanakana;
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  filters,
  render: (h) => h(App),
}).$mount("#app");
